const nextPath = path => {
  const pieces = path.split('.')
  const nextPieces = pieces
    .slice(0, pieces.length - 1)
    .concat([+pieces[pieces.length - 1] + 1])
  return nextPieces.join('.')
}

export default nextPath
